export interface FaqItem {
  q: string
  a: string
}

/** Grounded in the product sheets and verified company facts — no invented claims. */
export const faqs: FaqItem[] = [
  {
    q: 'What kinds of products does GreenbayBio make?',
    a: 'Bio-based crop inputs across five areas: soil-biology bio-fertilizers (AGN, AGN LTE, BIODYNAMIC), soil improvers (Biovin), biostimulants (Fulvic 25, AminOPF), plant-strength foliars (C4L Biofoliar, Nature’s Green 4+, Plant Armor Elite) and water management (Hydretain).',
  },
  {
    q: 'Are GreenbayBio products organic?',
    a: 'Several products are approved for use in organic farming under NPOP (India); some are also registered under FCO, approved under EU Reg. 834/2007 & NOP (Biovin), or the USDA BioPreferred® programme (Hydretain). Approvals vary by product — the exact licence is listed on each product page.',
  },
  {
    q: 'How do bio-fertilizers like AGN and BIODYNAMIC work?',
    a: 'They introduce a large population of beneficial phosphate-solubilizing bacteria (PSB) into the rhizosphere — the soil around plant roots. These microbes compete with harmful organisms for space and resources and release enzymes that break organic matter into forms crops can absorb, helping rebuild soil biology.',
  },
  {
    q: 'Why does AGN need to be incubated before use?',
    a: 'AGN and AGN LTE use encapsulation technology that keeps microbial spores dormant for shelf stability. Mixing 1:40 with water and incubating for at least one hour at room temperature activates the spores before you apply the product to the soil.',
  },
  {
    q: 'Can I mix these products with pesticides or fungicides?',
    a: 'For the microbial bio-fertilizers (AGN, AGN LTE, BIODYNAMIC), do not mix with fungicides, pesticides or weedicides — keep a gap of at least 48 hours before or after. Several biostimulants and foliar products can be combined with other inputs; always check the “How to use” section on each product page.',
  },
  {
    q: 'How do I choose the right product for my crop?',
    a: 'Use the Crop Solutions section. Each crop page lists recommended products drawn from our verified, crop-by-crop application programmes, along with a short programme note.',
  },
  {
    q: 'How should products be stored, and how long do they last?',
    a: 'Store products in a dry, frost-free place away from direct sunlight. Shelf life is three years for the AGN family and BIODYNAMIC, and five years for most other products — see each product page for details.',
  },
  {
    q: 'Do you guarantee higher yields or income?',
    a: 'No. We don’t promise guaranteed yields or income. Our products are designed to support healthy soil biology and plant strength; results depend on many factors outside our control, including soil condition, climate and crop management.',
  },
  {
    q: 'Are the products safe to handle?',
    a: 'They are crop inputs, not for ingestion. Wash hands after handling, wear protective clothing where indicated, keep away from children, food and feed, and follow the precautions printed on the label and product page.',
  },
  {
    q: 'How can I become a retailer or distributor?',
    a: 'Use the “Become a retailer” or “Become a distributor” enquiry pages, or contact us directly. Our team will get back to you to discuss partnering.',
  },
]
